import React from 'react';
interface Props {
  value: string;
  handleOnClick: () => void;
  className?: string;
  id?: string;
  innerClassname?: string;
}

export default function Chip(props: Props) {
  const { value, handleOnClick, className, innerClassname, id } = props;

  return (
    <button
      id={id}
      onClick={handleOnClick}
      type="button"
      className={`flex items-center bg-white py-[4px] px-[12px] rounded-full mr-2 ${
        className ? className : ''
      }`}
    >
      <span
        className={
          'text-sm font-bold text-center text-gray-600 whitespace-nowrap ' +
          (innerClassname || '')
        }
      >
        {value}
      </span>
    </button>
  );
}
